module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_500_Active@1x-e9b881e8b49abf94eec27abec3255596.png";